import { render, staticRenderFns } from "./TopGradientBlockLayout.vue?vue&type=template&id=0cf11980&"
import script from "./TopGradientBlockLayout.vue?vue&type=script&lang=js&"
export * from "./TopGradientBlockLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports